/** Юридические документы (внешние короткие ссылки). */
export const LEGAL_LINK_URLS = {
    privacy: "https://clck.ru/3TSNZM",
    publicOffer: "https://clck.ru/3TSNad",
    userAgreement: "https://clck.ru/3TSNbB",
};
export const LEGAL_LINK_ENTRIES = [
    {
        key: "privacy",
        href: LEGAL_LINK_URLS.privacy,
        labelRu: "Политика конфиденциальности",
        labelEn: "Privacy Policy",
    },
    {
        key: "publicOffer",
        href: LEGAL_LINK_URLS.publicOffer,
        labelRu: "Публичная оферта",
        labelEn: "Public Offer",
    },
    {
        key: "userAgreement",
        href: LEGAL_LINK_URLS.userAgreement,
        labelRu: "Пользовательское соглашение",
        labelEn: "User Agreement",
    },
];
